import { monthNames, monthShortNames } from '@Components/Utilities/SandhillsConstants';
import translator from '@Components/Utilities/Translator';

export default function EventDateCalendar(props) {

    const getMonthName = (monthIndex) => {
        let monthName = '';

        if (monthIndex != null) {
            if (monthIndex === 4 || monthIndex === 5 || monthIndex === 6) {
                monthName = translator.translate('sandhills.crm.dscrm.' + monthNames[monthIndex]);
            } else {
                monthName = translator.translate('sandhills.dealerservices.analytics.mvc.' + monthShortNames[monthIndex]);
            }
        }

        return monthName;
    };

    return (
        <div className='event-date-calendar'>
            <div className='event-date-calendar-container'>
                <strong><span className='event-date-calendar-month'>{getMonthName(props.MonthIndex)}</span></strong>
                <strong><span className='event-date-calendar-date'>{props.DateIndex.toString().padStart(2, '0')}</span></strong>
            </div>
            {props.StartTime &&
                <strong><span className='event-date-calendar-start-time'>{props.StartTime}</span></strong>}
        </div>
    );
};